import styled from 'styled-components';

export const ContainerStyled = styled.div`
    margin: 100px 45px 50px;

    @media (max-width: ${({ theme }) => theme.screenSm}) {
        margin: 87px 5px 30px;
    }
`;
